// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'primary', 'primary Fallback'"},"className":"__className_89c533","variable":"__variable_89c533"};